import { Box, Typography } from '@mui/material'
import type { TFile } from '@modules/types'
import { FilePreview } from '@modules/file-preview'
import { sectionTitleSx, flexWrapContainerSx, fileCardSx } from '../styles'

interface FilesSectionProps {
  files: TFile[]
  requestId: number
}

export const FilesSection = ({ files, requestId }: FilesSectionProps) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={sectionTitleSx}>Files ({files.length})</Typography>
      <Box sx={flexWrapContainerSx}>
        {files.map((file, index) => (
          <Box key={file.id || index} sx={fileCardSx}>
            <FilePreview file={file} requestId={requestId} />
          </Box>
        ))}
      </Box>
    </Box>
  )
}
